<template>
  <div v-if="roomStatus && roomStatus.length" class="room-status-statistics">
    <div :class="['statistics-list', { open: open }]">
      <div class="statistic-item" v-for="item in roomStatus" :key="item.code">
        <div class="value" @click.stop="onChecked(item)">
          <span
            :style="{ background: item.Data.Color }"
            :class="['color-spot', { active: checkId == item.Id }]"
          >
          </span>
          {{ item.Text }}
        </div>
        <div class="name">{{ item.count }}</div>
      </div>
    </div>
    <div :class="['collapse-button', { open: open }]" @click="toggleOpen">
      <span class="icon"></span>
    </div>
  </div>
</template>
<script>
import { Checkbox } from "vant";
export default {
  components: { [Checkbox.name]: Checkbox },
  props: {
    roomStatus: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return { open: false, checkId: "" };
  },
  methods: {
    toggleOpen() {
      this.open = !this.open;
    },
    onChecked(item) {
      if (item.Id == this.checkId) {
        this.checkId = "";
        this.$emit("checked", {});
      } else {
        this.checkId = item.Id;
        this.$emit("checked", item);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.room-status-statistics {
  background: #ebf3ff;
  margin-bottom: 5px;
  .statistics-list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    height: 49px;
    overflow: hidden;
    .statistic-item {
      text-align: center;
      padding: 5px 5px;
      display: flex;
      .value {
        font-size: 12px;
        color: #999;
        display: flex;
        align-items: center;
        margin-right: 3px;
        .color-spot {
          font-size: 12px;
          position: relative;
          &.active {
            &:after {
              content: "";
              width: 5px;
              height: 10px;
              position: absolute;
              right: 4px;
              bottom: 4px;
              border: 1px solid #000;
              border-top-color: transparent;
              border-left-color: transparent;
              transform: rotate(45deg);
            }
          }
        }
      }
      .name {
        font-size: 14px;
        color: #5192fc;
      }
    }
    &.open {
      height: auto;
    }
  }
  .collapse-button {
    text-align: center;
    .icon {
      position: relative;
      width: 40px;
      display: inline-block;
      height: 20px;
      &::before,
      &::after {
        content: "";
        position: absolute;
        width: 20px;
        height: 3px;
        background: #ddd;
        top: 8px;
      }
      &::before {
        transform: rotate(13deg);
        left: 0;
      }
      &::after {
        transform: rotate(-13deg);
        right: 0;
      }
    }
    &.open {
      .icon {
        &::before {
          transform: rotate(-13deg);
        }
        &::after {
          transform: rotate(13deg);
        }
      }
    }
  }
  .status-lable {
    font-size: 14px;
  }
}
.color-spot {
  display: inline-block;
  width: 15px;
  height: 15px;
  // background: #ddd;
  margin-right: 2px;
  border: 1px solid #ddd;
}
</style>
